<template>
  <button
    class="retry-icon-btn"
    :disabled="retrying || succeeded"
    :data-tippy-content="succeeded ? 'Payment succeeded' : 'Retry Manually'"
    data-cy="manual-retry-btn"
    @click="handleRetry"
  >
    <i v-if="retrying" class="fas fa-spinner fa-spin"></i>
    <i v-else-if="succeeded" class="fas fa-check"></i>
    <i v-else class="fas fa-undo"></i>
  </button>
</template>

<script>
import { EventBus } from "@/lib/event_bus.js";

export default {
  props: {
    invoiceId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      retrying: false,
      succeeded: false
    };
  },
  methods: {
    highlightRow(status) {
      const row = this.$el.closest("tr");
      if (!row) return;

      const color = status === "success" ? "#d4edda" : "#f8d7da";
      row.style.cssText = `background-color: ${color} !important; transition: background-color 0.3s;`;
      row.classList.add("retry-highlighted");
    },
    async handleRetry() {
      this.retrying = true;

      try {
        const csrfToken = document.querySelector(
          'meta[name="csrf-token"]'
        )?.content;

        const url = `${window.location.origin}/memberships/retry_payment`;
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-Token": csrfToken
          },
          body: JSON.stringify({ invoice_id: this.invoiceId })
        });

        const data = await response.json();

        if (response.ok && data.success) {
          this.succeeded = true;
          this.highlightRow("success");
          window.notify.success("Payment retry succeeded");
        } else {
          window.notify.error(data.error || "Payment retry failed");
        }
      } catch {
        window.notify.error("Payment retry failed");
      } finally {
        this.retrying = false;
      }
    }
  }
};
</script>

<style scoped>
.retry-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid #9ca3af;
  border-radius: 50%;
  background: none;
  color: #6b7280;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.15s;
}
.retry-icon-btn:hover:not(:disabled) {
  border-color: #6b7280;
  background-color: #f3f4f6;
}
.retry-icon-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
